import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import Auth from "../auth";
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    const loggedUser = Auth.getLoggedUser();
    if (loggedUser == null) {
      next({name: 'login'})
    } else {
      let canUserDo = true;
      to.matched.forEach(element => {
        if (element.meta.requiresActions) {
          if (!Auth.canUserDo(element.meta.requiresActions, loggedUser)) {
            canUserDo = false;
          }
      }
      });
      if (canUserDo) {
        if (!loggedUser.loggedAt || (new Date).getTime() - loggedUser.loggedAt > (60 * 60 * 24) * 1000) {
          Auth.deleteLoggedUser();
          next({name: 'login'})
        } else {
          next()
        }
      } else {
        Auth.deleteLoggedUser();
        next({name: 'login'})
      }
    }
  } else {
    if (to.matched.some(record => ['login', 'register'].indexOf(record.name) > -1)) {
      if (to.query.rapp && to.query.rapp !== '') {
        localStorage.setItem('redirect_app', to.query.rapp)
      }
      if (to.query.rurl && to.query.rurl !== '') {
        localStorage.setItem('redirect_url', to.query.rurl)
      }
      if (Auth.getLoggedUser()) {
        next({name: 'home'})
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

export default router;
